/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Keys_Expiry_HintInputs */

const vi_api_keys_expiry_hint = /** @type {(inputs: Api_Keys_Expiry_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bỏ trống nếu muốn khóa vĩnh viễn (không hết hạn).`)
};

/**

* @param {Api_Keys_Expiry_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const api_keys_expiry_hint = /** @type {((inputs?: Api_Keys_Expiry_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Keys_Expiry_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_api_keys_expiry_hint(inputs)
});